import React from "react";
import { Box, Typography, Button } from "@mui/material";
import support from './../../../assets/images/signin/support.jpg'
import { IoMdCall } from "react-icons/io";
import { useNavigate } from "react-router";

const ReviewPage = ({ t,phoneNumber }) => {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                minHeight: "100vh",
                padding: 3,
                backgroundColor: "#FFFFFF",
            }}
        >
            {/* Hourglass illustration */}
            <Box sx={{ mb: 2 }}>
                <img src={support} alt="support" style={{ width: "100%" }} />
            </Box>
            {/* Main text */}
            <Typography variant="h6" gutterBottom sx={{
                color: "#000", mb: "10px"
            }}>
                {t.reviewPage.mainMessage}            </Typography>
            {/* Contact information */}
            <Typography variant="body1" color="textSecondary" sx={{ mb: "10px", color: "#797979" }}>
                {t.reviewPage.contactMessage}            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '16px',
                    gap: '12px',
                    color: "#12538B",
                    mb: "68px"
                }}
            >
                <IoMdCall size={20} color="#12538B" />
                <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#12538B' }}>
                   {phoneNumber}
                </Typography>
            </Box>
            {/* Close button */}
            <Button
                onClick={() => {
                    navigate('/signin');
                }}
                variant="contained"
                color="primary"
                sx={{ borderRadius: "5px", padding: "10px 30px", color: "#fff", backgroundColor: "#12538B" }}
            >
                {t.reviewPage.closeButton}
            </Button>
        </Box>
    );
};

export default ReviewPage;
